/**
 * Created by Jerker Nord on 2018-06-04.
 */

import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {IceIceYetiGameAssets} from "../IceIceYetiGameAssets";

export class StickyWild extends PIXI.Container {

    private _originalSymbol:StateReelSymbol;
    private _originalPosition:PIXI.Point;
    private _wildAnimation:TimelineSprite;
    private _animationIndex:number;

    constructor(originalSymbol:StateReelSymbol, originalPosition:PIXI.Point, animationIndex:number) {
        super();
        this._originalSymbol = originalSymbol;
        this._originalPosition = originalPosition;
        this._animationIndex = animationIndex;

        let textureName:string;
        let offsetX:number = 0;
        let offsetY:number = 0;
        if(animationIndex == 0) {
            textureName = IceIceYetiGameAssets.WILD_PRESENTATION_01;
            offsetY = 3;
            offsetX = 1;
        } else {
            textureName = IceIceYetiGameAssets.WILD_PRESENTATION_02;
            offsetY = 1;
        }

        this._wildAnimation = new TimelineSprite((GameResources.getTextures(textureName)));
        this._wildAnimation.anchor.set(0.5, 0.5);
        this._wildAnimation.position.set(offsetX, offsetY);
        this._wildAnimation.visible = false;
        this.addChild(this._wildAnimation);
    }

    public getAnimation(frames:number[]):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => {
            this._wildAnimation.show();
            const originalSymbol:StateReelSymbol | null = Reels.getSymbol(this.originalPosition.x, this.originalPosition.y);
            if(originalSymbol) {
                originalSymbol.setVisibility(false);
            }
        });
        timeline.add(this._wildAnimation.getAnimation(frames));

        return timeline;
    }

    get originalPosition():PIXI.Point {
        return this._originalPosition;
    }

    get animationIndex():number {
        return this._animationIndex;
    }
}